const InitialGridConfig = {
  ROW_COUNT: 20,
  COLUMN_COUNT: 20,
  HIGHLIGHT_COLOR: "#fca311",
  UNSELECTED_CELL_COLOR: "#FFFFFF"
};

export default InitialGridConfig;
